import { render, staticRenderFns } from "./RedirectPlugin.vue?vue&type=template&id=5d4281d6&scoped=true"
import script from "./RedirectPlugin.vue?vue&type=script&lang=ts"
export * from "./RedirectPlugin.vue?vue&type=script&lang=ts"
import style0 from "./RedirectPlugin.vue?vue&type=style&index=0&id=5d4281d6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4281d6",
  null
  
)

export default component.exports